import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const modeloDatos = {
    SuplidorID: 0, 
    empresaID: 1,
    descripcion: "",
    telefono:"",
    nombreVendedor: "",
    rnc: "",
    direccion: "",
 
    fechaCreado: new Date,
   
}

const Suplidor = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Impresion, setImpresion] = useState(false);
    const [R_API, setR_API] = useState("")

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }


    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaSuplidor");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
            setR_API(Api + "VentasMantenimiento/listaSuplidor")
        }
    }

    useEffect(() => {
        obtenerDatos();
    },[])


    const guardarCambios = async () => {
      

        let response;
        if (tabla.SuplidorID == 0) {
          
            response = await fetch(Api + "VentasMantenimiento/GuardarSuplidor", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasMantenimiento/EditarSuplidor", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            await obtenerDatos();
            setTabla(modeloDatos)
            setVerModal(!verModal);
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "evaluaciondesempeno/EliminarPregunta/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.suplidorID,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },
       
       
        //{
        //    name: 'Estado',
        //    selector: row => row.esActivo,
        //    sortable: true,
        //    cell: row => {
        //        let clase;
        //        clase = row.esActivo ? "badge badge-info p-2" : "badge badge-danger p-2"
        //        return (
        //            <span className={clase}>{row.esActivo ? "Activo" : "No Activo"}</span>
        //        )
        //    }
        //}
        ,
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Suplidor
                </CardHeader>
                <CardBody>
               
                    <div class="box">
                        <div>      <Button color="success" size="sm"
                            onClick={() => setVerModal(!verModal)}
                        >Nuevo Suplidor</Button> </div>
                        <div>  <button size="sm" color="primary" class="btn-search" block onClick={() => setImpresion(true)}>
                            <i class="fas fa-print"></i> Imprimir
                        </button></div>
                    </div>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className="modal-header1">
                    Mantenimiento de Suplidor
                </ModalHeader>
                <ModalBody>
                    <Row>
                    <Col >
                    <FormGroup>
                        <Label>Descripcion</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup>
                        </Col>
                        <Col >
                            <FormGroup>
                                <Label>RNC</Label>
                                <Input bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                            </FormGroup>
                        </Col>
                        <Col >
                            <FormGroup>
                                <Label>Direccion</Label>
                                <Input bsSize="sm" name="direccion" onChange={handleChange} value={tabla.direccion} />
                            </FormGroup>
                        </Col>
                        <Col >
                            <FormGroup>
                                <Label>Telefono</Label>
                                <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                            </FormGroup>
                        </Col>
                        <Col >
                            <FormGroup>
                                <Label>NombreVendedor</Label>
                                <Input bsSize="sm" name="nombreVendedor" onChange={handleChange} value={tabla.nombreVendedor} />
                            </FormGroup>
                        </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                      onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        
            <Modal className="modal-preguntas" isOpen={Impresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {<iframe
                                src={"/Informes/CXP/listadosuplidores.htm?API=" + R_API}
                                title="Contenido HTML"
                                style={{ width: '100%', height: '1100px', border: 'none' }}

                            />}


                            <Button size="sm" color="danger"
                                onClick={() => setImpresion(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

        </>
        )

}
export default Suplidor;